import React from 'react';
import {string} from 'prop-types';

const Processing = ( {children, label='Loading...'} ) =>
    <div className="bg-moon-grey rounded-full inline-block my-4">
        <div className="flex items-center leading-collapse p-2 pr-4">
            <span className="mr-2 w-6 h-6 spinner-reverse"/>
            {children || label}
        </div>
    </div>;

Processing.propTypes = {
    label: string
};

export default Processing;
